(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ff-a2-learning"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function openLinkedAnswer() {
      if (!window.location.hash.startsWith('#ff-a2-question-')) return;
      const answer = document.getElementById(window.location.hash.slice(1));
      if (answer instanceof HTMLDetailsElement) answer.open = true;
    }
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      const link = event.target.closest('.ff-a2-learning__guides a');
      if (!link || !link.hash.startsWith('#ff-a2-question-')) return;
      const answer = document.getElementById(link.hash.slice(1));
      if (answer instanceof HTMLDetailsElement) {
        answer.open = true;
        answer.querySelector('summary')?.focus({ preventScroll: true });
      }
    });
    window.addEventListener('hashchange', openLinkedAnswer);
    document.addEventListener('shopify:section:load', openLinkedAnswer);
    openLinkedAnswer();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-collection-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ff-collection-slider')) {
 customElements.define('ff-collection-slider', class extends HTMLElement {
  connectedCallback() {
   this.abort?.abort();
   this.abort = new AbortController();
   const signal = this.abort.signal;
   const track = this.querySelector('.ffcs__track');
   const buttons = [...this.querySelectorAll('[data-direction]')];
   const update = () => {
    if (this.frame) return;
    this.frame = requestAnimationFrame(() => {
     this.frame = 0;
     const left = track.scrollLeft, total = track.scrollWidth, width = track.clientWidth;
     buttons[0].disabled = left <= 2;
     buttons[1].disabled = left >= total - width - 2;
    });
   };
   buttons.forEach(button => button.addEventListener('click', () => {
    const card = track.querySelector('.ffcs__card');
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    track.scrollBy({left: Number(button.dataset.direction) * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
   }, {signal}));
   track.addEventListener('scroll', update, {passive:true, signal});
   this.addEventListener('shopify:block:select', event => event.target.closest('.ffcs__card')?.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'}), {signal});
   this.observer = new ResizeObserver(update);
   this.observer.observe(track);
   update();
  }
  disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame); this.frame = 0; }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-favourites"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ff-favourites')) {
  customElements.define('ff-favourites', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.tabs = Array.from(this.querySelectorAll('[data-fff-target]'));
      this.panels = Array.from(this.querySelectorAll('[data-fff-panel]'));
      const navigation = this.querySelector('.fff__tabs');
      if (!navigation || !this.tabs.length) return;
      navigation.setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', tab.dataset.fffTarget);
        tab.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.activate(index);
        });
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault();
          this.activate(next);
          this.tabs[next].focus();
        });
      });
      this.panels.forEach(panel => panel.setAttribute('role', 'tabpanel'));
      this.activate(0);
      this.onBlockSelect = event => {
        const index = this.panels.findIndex(panel => panel === event.target || panel.contains(event.target));
        if (index >= 0) this.activate(index);
      };
      this.addEventListener('shopify:block:select', this.onBlockSelect);
    }
    activate(index) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      const selected = this.tabs[index].dataset.fffTarget;
      this.panels.forEach(panel => { panel.hidden = panel.id !== selected; });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-ghee-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ff-ghee-hero'))customElements.define('ff-ghee-hero',class extends HTMLElement{
connectedCallback(){
 if(this.abort)return;this.abort=new AbortController();const options={signal:this.abort.signal};this.track=this.querySelector('.ffg-hero__track');this.slides=[...this.querySelectorAll('[data-slide]')];this.dots=[...this.querySelectorAll('[data-dot]')];this.index=0;this.paused=false;this.reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;if(this.slides.length<2)return;
 this.go=(i)=>{this.index=(i+this.slides.length)%this.slides.length;this.track.scrollTo({left:this.slides[this.index].offsetLeft,behavior:this.reduced?'auto':'smooth'})};
 this.querySelector('[data-prev]').addEventListener('click',()=>{this.go(this.index-1);this.start()},options);this.querySelector('[data-next]').addEventListener('click',()=>{this.go(this.index+1);this.start()},options);this.dots.forEach((d,i)=>d.addEventListener('click',()=>{this.go(i);this.start()},options));
 this.track.addEventListener('scroll',()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>{this.index=this.slides.reduce((best,s,i)=>Math.abs(s.offsetLeft-this.track.scrollLeft)<Math.abs(this.slides[best].offsetLeft-this.track.scrollLeft)?i:best,0);this.dots.forEach((d,i)=>d.setAttribute('aria-current',String(i===this.index)))})},{...options,passive:true});
 this.addEventListener('mouseenter',()=>clearInterval(this.timer),options);this.addEventListener('mouseleave',()=>this.start(),options);this.addEventListener('focusin',()=>clearInterval(this.timer),options);this.addEventListener('focusout',()=>this.start(),options);document.addEventListener('visibilitychange',()=>this.start(),options);
 const pause=this.querySelector('[data-pause]');if(pause)pause.addEventListener('click',()=>{this.paused=!this.paused;pause.setAttribute('aria-label',this.paused?pause.dataset.playLabel:pause.dataset.pauseLabel);pause.querySelector('span').textContent=this.paused?'▷':'Ⅱ';this.start()},options);
 this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.start()},{threshold:.15});this.observer.observe(this);
 this.width=this.track.clientWidth;this.resize=new ResizeObserver(()=>{const width=this.track.clientWidth;if(Math.abs(width-this.width)<1)return;this.width=width;this.track.scrollTo({left:this.slides[this.index].offsetLeft,behavior:'instant'})});this.resize.observe(this.track);
 this.addEventListener('shopify:block:select',event=>{const i=this.slides.findIndex(s=>s.contains(event.target));if(i>=0)this.go(i);clearInterval(this.timer)},options);
}
start(){clearInterval(this.timer);if(this.dataset.autoplay==='true'&&!this.paused&&!this.reduced&&this.visible&&!document.hidden&&!this.contains(document.activeElement))this.timer=setInterval(()=>this.go(this.index+1),Number(this.dataset.interval)||6500)}
disconnectedCallback(){this.abort?.abort();this.abort=null;this.observer?.disconnect();this.resize?.disconnect();clearInterval(this.timer);cancelAnimationFrame(this.frame)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-ghee-products"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ff-ghee-shop'))customElements.define('ff-ghee-shop',class extends HTMLElement{
connectedCallback(){if(this.abort)return;this.abort=new AbortController();const opts={signal:this.abort.signal};const cards=[...this.querySelectorAll('.ffg-card')];this.querySelectorAll('[data-filter]').forEach(b=>b.addEventListener('click',()=>{this.querySelectorAll('[data-filter]').forEach(t=>t.setAttribute('aria-pressed',String(t===b)));cards.forEach(c=>c.hidden=b.dataset.filter!=='all'&&!c.dataset.categories.split(' ').includes(b.dataset.filter));this.querySelector('.ffg-empty').hidden=cards.some(c=>!c.hidden)},opts));cards.forEach(c=>{let images=JSON.parse(c.querySelector('[data-images]').textContent),i=0;const img=c.querySelector('.ffg-card__image img'),count=c.querySelector('[data-image-count]');const show=(src,alt)=>{if(!img)return;img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=src;img.alt=alt||''};const move=d=>{i=(i+d+images.length)%images.length;show(images[i].src,images[i].alt);count.textContent=(i+1)+' / '+images.length};c.querySelector('[data-image-prev]')?.addEventListener('click',()=>move(-1),opts);c.querySelector('[data-image-next]')?.addEventListener('click',()=>move(1),opts);c.addEventListener('change',e=>{const input=e.target;if(!input.matches('input[type=radio]'))return;show(input.dataset.image,input.dataset.alt);i=Math.max(0,images.findIndex(im=>im.src===input.dataset.image));if(count)count.textContent=(i+1)+' / '+images.length;c.querySelectorAll('[data-product-link]').forEach(a=>a.href=input.dataset.url);c.querySelector('[data-price]').replaceChildren(...[...input.parentElement.querySelector('[data-variant-price]').childNodes].map(n=>n.cloneNode(true)));const compare=c.querySelector('[data-compare]');compare.replaceChildren(...[...input.parentElement.querySelector('[data-variant-compare]').childNodes].map(n=>n.cloneNode(true)));compare.hidden=!input.dataset.compare;window.ffSetWishlistVariant?.(c,input.value);const sale=c.querySelector('[data-sale]');sale.hidden=!input.dataset.saving;if(input.dataset.saving)sale.textContent=sale.textContent.replace(/\d+%/,input.dataset.saving+'%');const button=c.querySelector('[type=submit]');button.disabled=input.dataset.available!=='true';button.textContent=button.disabled?button.dataset.sold:button.dataset.add},opts)})}
disconnectedCallback(){this.abort?.abort();this.abort=null}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-hero-media"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ff-hero-media')) {
 customElements.define('ff-hero-media',class extends HTMLElement {
  connectedCallback(){
   if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;
   this.track=this.querySelector('.ffhm__track');this.slides=[...this.track.children];this.dots=[...this.querySelectorAll('[data-go]')];if(!this.slides.length)return;this.index=0;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;this.visible=false;this.hovered=false;this.saveData=!!navigator.connection?.saveData;this.loaded=document.readyState==='complete';if(!this.loaded)window.addEventListener('load',()=>{this.loaded=true;this.refresh();},{once:true,signal});
   this.center=(slide,behavior='instant')=>{const frame=this.track.getBoundingClientRect(),rect=slide.getBoundingClientRect();this.track.scrollTo({left:this.track.scrollLeft+rect.left-frame.left-(frame.width-rect.width)/2,behavior});};
   this.motion=()=>matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth';
   this.go=n=>{this.index=(n+this.slides.length)%this.slides.length;this.center(this.slides[this.index],this.motion());this.refresh();};
   this.querySelectorAll('[data-step]').forEach(b=>b.addEventListener('click',()=>this.go(this.index+Number(b.dataset.step)),{signal}));this.dots.forEach(b=>b.addEventListener('click',()=>this.go(Number(b.dataset.go)),{signal}));
   this.pauseButton=this.querySelector('.ffhm__pause');this.pauseButton.addEventListener('click',()=>{this.paused=!this.paused;this.saveData=false;this.refresh();},{signal});
   this.addEventListener('mouseenter',()=>{this.hovered=true;this.schedule();},{signal});this.addEventListener('mouseleave',()=>{this.hovered=false;this.schedule();},{signal});
   this.addEventListener('focusin',()=>{this.hovered=true;this.schedule();},{signal});this.addEventListener('focusout',e=>{if(!this.contains(e.relatedTarget)){this.hovered=false;this.schedule();}},{signal});
   this.track.addEventListener('scroll',()=>{clearTimeout(this.settle);this.settle=setTimeout(()=>{const frame=this.track.getBoundingClientRect(),center=frame.left+frame.width/2;const distance=el=>{const r=el.getBoundingClientRect();return Math.abs(r.left+r.width/2-center);};let closest=[...this.track.children].reduce((a,b)=>distance(b)<distance(a)?b:a);this.index=Number(closest.dataset.slide);this.refresh();},120);},{passive:true,signal});
   this.addEventListener('shopify:block:select',e=>{const slide=e.target.closest('[data-slide]');if(slide){this.paused=true;this.go(Number(slide.dataset.slide));}},{signal});
   document.addEventListener('visibilitychange',()=>this.refresh(),{signal});
   this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.refresh();},{threshold:.2});this.observer.observe(this);
   let previousWidth=this.track.clientWidth;this.resize=new ResizeObserver(()=>{const width=this.track.clientWidth;if(Math.abs(width-previousWidth)>1){previousWidth=width;this.center(this.slides[this.index]);}});this.resize.observe(this.track);
   this.refresh();
  }
  schedule(){clearTimeout(this.timer);if(this.loaded&&this.dataset.autoplay==='true'&&!this.paused&&!this.hovered&&this.visible&&!document.hidden&&this.slides.length>1)this.timer=setTimeout(()=>this.go(this.index+1),Number(this.dataset.delay)||6500);}
  refresh(){this.slides.forEach((s,i)=>{s.classList.toggle('is-active',i===this.index);s.inert=i!==this.index;});this.dots.forEach((d,i)=>{if(i===this.index)d.setAttribute('aria-current','true');else d.removeAttribute('aria-current');});this.querySelectorAll('video').forEach(v=>{const slide=v.closest('[data-slide]');if(Number(slide.dataset.slide)===this.index&&!slide.dataset.clone&&!this.paused&&this.visible&&!document.hidden&&!this.saveData){if(!v.getAttribute('src')){v.src=v.dataset.previewSrc;v.addEventListener('playing',()=>v.classList.add('is-ready'),{once:true});}v.muted=true;if(v.paused)v.play().catch(()=>{});}else v.pause();});this.pauseButton.textContent=this.paused?'▷':'Ⅱ';this.pauseButton.setAttribute('aria-label',this.paused?this.pauseButton.dataset.playLabel:this.pauseButton.dataset.pauseLabel);this.schedule();}
  disconnectedCallback(){this.abort?.abort();this.abort=null;this.observer?.disconnect();this.resize?.disconnect();clearTimeout(this.timer);clearTimeout(this.settle);}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-promo-slider"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ff-promo'))customElements.define('ff-promo',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const track=this.querySelector('.ffp__track'),slides=[...track.children],dots=[...this.querySelectorAll('.ffp__dots button')];let index=0;const go=i=>{index=(i+slides.length)%slides.length;track.scrollTo({left:slides[index].offsetLeft,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});};this.querySelector('.ffp__prev').addEventListener('click',()=>go(index-1));this.querySelector('.ffp__next').addEventListener('click',()=>go(index+1));dots.forEach((d,i)=>d.addEventListener('click',()=>go(i)));track.addEventListener('scroll',()=>{index=Math.round(track.scrollLeft/track.clientWidth);dots.forEach((d,i)=>d.setAttribute('aria-pressed',i===index));},{passive:true});track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(index+(e.key==='ArrowRight'?1:-1));slides[index].focus({preventScroll:true});}});this.addEventListener('shopify:block:select',e=>{const n=slides.indexOf(e.target.closest('.ffp__slide'));if(n>=0)go(n);});if(slides.length<2){this.querySelectorAll('.ffp__arrow,.ffp__dots').forEach(el=>el.hidden=true);}}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-selected-products"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ff-selected')) customElements.define('ff-selected',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;const tabs=[...this.querySelectorAll('[role=tab]')],panels=[...this.querySelectorAll('[role=tabpanel]')];const hydrate=p=>{const tpl=p.querySelector(':scope > template[data-ffs-lazy]');if(tpl)tpl.replaceWith(tpl.content.cloneNode(true));};const activate=i=>{hydrate(panels[i]);tabs.forEach((t,j)=>{t.setAttribute('aria-selected',j===i);t.tabIndex=j===i?0:-1;panels[j].hidden=j!==i;});};tabs.forEach((t,i)=>{t.addEventListener('pointerenter',()=>hydrate(panels[i]),{once:true});t.addEventListener('click',()=>activate(i));t.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;e.preventDefault();activate(n);tabs[n].focus();});});this.addEventListener('shopify:block:select',e=>{const i=panels.indexOf(e.target.closest('[role=tabpanel]'));if(i>=0)activate(i);});this.addEventListener('change',e=>{const input=e.target;if(!input.matches('input[type=radio]'))return;const card=input.closest('.ffs__card'),price=card.querySelector('.ffs__price');const img=card.querySelector('.ffs__image img');if(img&&input.dataset.image){img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=input.dataset.image;img.alt=input.dataset.imageAlt||'';}card.querySelectorAll('.ffs__image,.ffs__title').forEach(link=>{link.href=input.dataset.url;});price.replaceChildren();const row=document.createElement('div');row.className='price price--center'+(input.dataset.compare?' price--on-sale':'');if(input.dataset.compare){const old=document.createElement('s');old.className='price-item price-item--regular';old.textContent=input.dataset.compare;old.style.marginRight='7px';row.append(old);}const current=document.createElement('span');current.className='price-item '+(input.dataset.compare?'price-item--sale':'price-item--regular');current.textContent=input.dataset.price;row.append(current);price.append(row);const button=card.querySelector('.ffs__add');button.disabled=input.dataset.available!=='true';button.textContent=button.disabled?button.dataset.soldLabel:button.dataset.addLabel;});}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"] && !Shopify.designMode) return;
  try {
    
    class StickyHeaderMobile extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.querySelector('.shopify-section__header-mobile');
            this.header_2 = document.querySelector('.shopify-section__header-mobile .header-mobile');
            this.headerBounds = {};
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.stickyHeaderType = this.getAttribute('data-sticky-type');

            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;

            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();

            this.setHeaderHeight();
            window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));
            this.backgroundTransparent();
        }

        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        setHeaderHeight() {
            if(document.querySelector('.section-header-single-line')) {
                this.header.style.setProperty('--header-height', `${this.header_2.offsetHeight}px`);
            } else {
                if(document.querySelector('.header-mobile-style-full')) {
                    if(document.querySelector('.header-mobile.header-transparent')) {
                        this.header.style.setProperty('--header-height', `calc(${this.header_2.offsetHeight}px + 40px)`);
                    } else {
                        this.header.style.setProperty('--header-height', `calc(${this.header.offsetHeight}px + 40px)`);
                    }
                } else {
                    if(document.querySelector('.header-mobile.header-transparent')) {
                        this.header.style.setProperty('--header-height', `${this.header_2.offsetHeight}px`);
                    } else {
                        this.header.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
                    }
                }
            }
        }

        backgroundTransparent() {
            if (document.querySelector('.header-mobile.header-transparent')) {
                this.header.classList.add('enable-bg-transparent');
            }
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if(!document.body.classList.contains('open-search')){
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);

                    this.isScrolling = setTimeout(() => {
                        this.preventReveal = false;
                    }, 66);

                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                requestAnimationFrame(this.reset.bind(this));
            }

            this.currentScrollTop = scrollTop;
        }

        hide() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    document.body.classList.add('scroll-down');
                    document.body.classList.remove('scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
            this.closeMenuDisclosure();
            this.closeDropdownPopup();
        }

        reveal() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    this.header.classList.remove('shopify-section-header-hidden');
                    document.body.classList.add('scroll-up');
                    document.body.classList.remove('scroll-down');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
        }

        reset() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-down', 'scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-up');
                    return
                }
            }
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }

        closeDropdownPopup() {
            if(this.querySelector('.dropdown-language-currency')){
                this.querySelector('.dropdown-language-currency').classList.remove('show');
            }
        }
    }

    if (!customElements.get('sticky-header-mobile')) customElements.define('sticky-header-mobile', StickyHeaderMobile);

    document.querySelector('[data-mobile-menu]').addEventListener('click', () => {
        document.body.classList.toggle('menu-open');
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-basic"] && !Shopify.designMode) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.querySelector('.section-header-navigation');
            this.header_2 = document.querySelector('.section-header-navigation .header-nav-basic');
            this.headerBounds = {};
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.headerName = document.querySelector('.shopify-section__header-nav-basic');
            this.stickyHeaderType = this.getAttribute('data-sticky-type');

            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;

            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();

            this.setHeaderHeight();
            window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));
            this.backgroundTransparent();
        }

        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        setHeaderHeight() {
            document.querySelector('.section-header-single-line') || this.headerName.querySelector('.transparent') ? this.headerName.style.setProperty('--header-height', `${this.header_2.offsetHeight}px`) : this.headerName.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        backgroundTransparent() {
            if (this.headerName.querySelector('.transparent')) {
                this.headerName.classList.add('enable-bg-transparent');
            }
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if(!document.body.classList.contains('open-search')){
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);

                    this.isScrolling = setTimeout(() => {
                        this.preventReveal = false;
                    }, 66);

                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                requestAnimationFrame(this.reset.bind(this));
            }

            this.currentScrollTop = scrollTop;
        }

        hide() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    document.body.classList.add('scroll-down');
                    document.body.classList.remove('scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
            this.closeMenuDisclosure();
            this.closeDropdownPopup();
        }

        reveal() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    this.header.classList.remove('shopify-section-header-hidden');
                    document.body.classList.add('scroll-up');
                    document.body.classList.remove('scroll-down');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
        }

        reset() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-down', 'scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-up');
                    return
                }
            }
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }

        closeDropdownPopup() {
            if(this.querySelector('.dropdown-language-currency')){
                this.querySelector('.dropdown-language-currency').classList.remove('show');
            }
        }
    }

    customElements.define('sticky-header-basic', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-classic"] && !Shopify.designMode) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.querySelector('.section-header-navigation');
            this.header_2 = document.querySelector('.section-header-navigation .header-nav-classic');
            this.headerBounds = {};
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.headerName = document.querySelector('.shopify-section__header-nav-classic');
            this.stickyHeaderType = this.getAttribute('data-sticky-type');

            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;

            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();

            this.setHeaderHeight();
            window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));
            this.backgroundTransparent();
        }

        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        setHeaderHeight() {
            document.querySelector('.section-header-single-line') || this.headerName.querySelector('.transparent') ? this.headerName.style.setProperty('--header-height', `${this.header_2.offsetHeight}px`) : this.headerName.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        backgroundTransparent() {
            if (this.headerName.querySelector('.transparent')) {
                this.headerName.classList.add('enable-bg-transparent');
            }
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if(!document.body.classList.contains('open-search')){
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);

                    this.isScrolling = setTimeout(() => {
                        this.preventReveal = false;
                    }, 66);

                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                requestAnimationFrame(this.reset.bind(this));
            }

            this.currentScrollTop = scrollTop;
        }

        hide() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    document.body.classList.add('scroll-down');
                    document.body.classList.remove('scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
            this.closeMenuDisclosure();
            this.closeDropdownPopup();
        }

        reveal() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    this.header.classList.remove('shopify-section-header-hidden');
                    document.body.classList.add('scroll-up');
                    document.body.classList.remove('scroll-down');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
        }

        reset() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-down', 'scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-up');
                    return
                }
            }
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }

        closeDropdownPopup() {
            if(this.querySelector('.dropdown-language-currency')){
                this.querySelector('.dropdown-language-currency').classList.remove('show');
            }
        }
    }

    customElements.define('sticky-header-classic', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !Shopify.designMode) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.querySelector('.section-header-navigation');
            this.header_2 = document.querySelector('.section-header-navigation .header-nav-multi-site');
            this.headerBounds = {};
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.headerName = document.querySelector('.shopify-section__header-nav-multi-site');
            this.stickyHeaderType = this.getAttribute('data-sticky-type');

            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;

            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();

            this.setHeaderHeight();
            window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));
            this.backgroundTransparent();
        }

        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        setHeaderHeight() {
            document.querySelector('.section-header-single-line') || this.headerName.querySelector('.transparent') ? this.headerName.style.setProperty('--header-height', `${this.header_2.offsetHeight}px`) : this.headerName.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        backgroundTransparent() {
            if (this.headerName.querySelector('.transparent')) {
                this.headerName.classList.add('enable-bg-transparent');
            }
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if(!document.body.classList.contains('open-search')){
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);

                    this.isScrolling = setTimeout(() => {
                        this.preventReveal = false;
                    }, 66);

                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                requestAnimationFrame(this.reset.bind(this));
            }

            this.currentScrollTop = scrollTop;
        }

        hide() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    document.body.classList.add('scroll-down');
                    document.body.classList.remove('scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
            this.closeMenuDisclosure();
            this.closeDropdownPopup();
        }

        reveal() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    this.header.classList.remove('shopify-section-header-hidden');
                    document.body.classList.add('scroll-up');
                    document.body.classList.remove('scroll-down');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
        }

        reset() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-down', 'scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-up');
                    return
                }
            }
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }

        closeDropdownPopup() {
            if(this.querySelector('.dropdown-language-currency')){
                this.querySelector('.dropdown-language-currency').classList.remove('show');
            }
        }
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-vertical-menu"] && !Shopify.designMode) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.querySelector('.section-header-navigation');
            this.header_2 = document.querySelector('.section-header-navigation .shopify-section__header-nav-vertical-menu');
            this.headerBounds = {};
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.headerName = document.querySelector('.shopify-section__header-nav-vertical-menu');
            this.stickyHeaderType = this.getAttribute('data-sticky-type');

            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;

            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
            this.setHeaderHeight();
            window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));
        }

        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        setHeaderHeight() {
            document.querySelector('.section-header-single-line') ? this.headerName.style.setProperty('--header-height', `${this.header_2.offsetHeight}px`) : this.headerName.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if(!document.body.classList.contains('open-search')){
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);

                    this.isScrolling = setTimeout(() => {
                        this.preventReveal = false;
                    }, 66);

                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                requestAnimationFrame(this.reset.bind(this));
            }

            this.currentScrollTop = scrollTop;
        }

        hide() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    document.body.classList.add('scroll-down');
                    document.body.classList.remove('scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
            this.closeMenuDisclosure();
            this.closeDropdownPopup();
        }

        reveal() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    this.header.classList.remove('shopify-section-header-hidden');
                    document.body.classList.add('scroll-up');
                    document.body.classList.remove('scroll-down');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
        }

        reset() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-down', 'scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-up');
                    return
                }
            }
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }

        closeDropdownPopup() {
            if(this.querySelector('.dropdown-language-currency')){
                this.querySelector('.dropdown-language-currency').classList.remove('show');
            }
        }
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !Shopify.designMode) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.querySelector('.section-header-navigation');
            this.header_2 = document.querySelector('.section-header-navigation .header-nav-full-elements');
            this.headerBounds = {};
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.headerName = document.querySelector('.shopify-section__header-nav-full-elements');
            this.stickyHeaderType = this.getAttribute('data-sticky-type');

            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;

            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();

            this.setHeaderHeight();
            window.matchMedia('(max-width: 1024px)').addEventListener('change', this.setHeaderHeight.bind(this));
            this.backgroundTransparent();
        }

        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        setHeaderHeight() {
            document.querySelector('.section-header-single-line') || this.headerName.querySelector('.transparent') ? this.headerName.style.setProperty('--header-height', `${this.header_2.offsetHeight}px`) : this.headerName.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        backgroundTransparent() {
            if (this.headerName.querySelector('.transparent')) {
                this.headerName.classList.add('enable-bg-transparent');
            }
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if(!document.body.classList.contains('open-search')){
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);

                    this.isScrolling = setTimeout(() => {
                        this.preventReveal = false;
                    }, 66);

                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                requestAnimationFrame(this.reset.bind(this));
            }

            this.currentScrollTop = scrollTop;
        }

        hide() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    document.body.classList.add('scroll-down');
                    document.body.classList.remove('scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
            this.closeMenuDisclosure();
            this.closeDropdownPopup();
        }

        reveal() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    this.header.classList.remove('shopify-section-header-hidden');
                    document.body.classList.add('scroll-up');
                    document.body.classList.remove('scroll-down');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.add('scroll-up');
                    return
                }
            }
        }

        reset() {
            if(this.stickyHeaderType != null) {
                if(this.stickyHeaderType === 'up') {
                    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-down', 'scroll-up');
                } else {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    document.body.classList.remove('scroll-up');
                    return
                }
            }
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }

        closeDropdownPopup() {
            if(this.querySelector('.dropdown-language-currency')){
                this.querySelector('.dropdown-language-currency').classList.remove('show');
            }
        }
    }

    customElements.define('sticky-header-full-elements', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
    class StickyHeader extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.header = document.getElementById('shopify-section-header');
            this.headerBounds = {};
            this.currentScrollTop = 0;
            this.preventReveal = false;

            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;

            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);

            this.createObserver();
        }

        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });

            observer.observe(this.header);
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if(!document.body.classList.contains('open-search')){
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);

                    this.isScrolling = setTimeout(() => {
                        this.preventReveal = false;
                    }, 66);

                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                requestAnimationFrame(this.reset.bind(this));
            }

            this.currentScrollTop = scrollTop;
        }

        hide() {
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.closeMenuDisclosure();
            this.closeDropdownPopup();
            document.body.classList.add('scroll-down');
            document.body.classList.remove('scroll-up');
        }

        reveal() {
            this.header.classList.add('shopify-section-header-sticky', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            document.body.classList.add('scroll-up');
            document.body.classList.remove('scroll-down');
        }

        reset() {
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
            document.body.classList.remove('scroll-down', 'scroll-up');
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }

        closeDropdownPopup() {
            if(this.querySelector('.dropdown-language-currency')){
                this.querySelector('.dropdown-language-currency').classList.remove('show');
            }
        }
    }

    customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
    class CartNote extends HTMLElement {
        constructor() {
            super();

            this.addEventListener('change', debounce((event) => {
                const body = JSON.stringify({ note: event.target.value });
                fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
            }, 300))
        }
    }

    customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();
})();
